import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import Button from '../../Assets/images/svg/black_back_button.svg';
import './backButton.scss';
const BackButton = ({ pageName, isActive, link, state = {} }) => {
  const navigate = useNavigate();

  const handleClick = (event) => {
    event.preventDefault(); // Prevents default anchor behavior
    if (isActive) {
      navigate(link, { state });
    }
  };

  return (
    <>
      {isActive && (
        <a
          href={link} // Provides a fallback for non-JS users
          onClick={handleClick}
          className="back-button-icon"
          aria-label={`Go back to ${pageName}`}
        >
          <img src={Button} alt={pageName} />
        </a>
      )}
      <span>{pageName}</span>
    </>
  );
};

BackButton.propTypes = {
  pageName: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  link: PropTypes.string.isRequired,
  state: PropTypes.object,
};

export default BackButton;
